import { api, API_BASE_URL } from '../../lib/apiClient';

export async function resolveShareMeta(token) {
  const { data } = await api.get(`/shares/public/${token}`, { skipAuth: true });
  return data;
}

export async function accessShare(token, password) {
  const { data } = await api.post(
    `/shares/public/${token}`,
    password ? { password } : {},
    { skipAuth: true },
  );
  return data;
}

export async function fetchSharedPreviewBlob({ token, fileId, password }) {
  const { data } = await api.get(`/shares/public/${token}/files/${fileId}/preview`, {
    skipAuth: true,
    responseType: 'blob',
    params: password ? { password } : {},
  });
  return data;
}

export async function downloadSharedFile({ token, fileId, name, password }) {
  const { data } = await api.get(`/shares/public/${token}/files/${fileId}/content`, {
    skipAuth: true,
    responseType: 'blob',
    params: password ? { password } : {},
  });
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

// ---- Chat & comments on an `allowChat` link — requires login (any account);
// the token identifies the resource, no `skipAuth` here since the default
// `api` client's bearer-token attachment is exactly what these need. ----
export const shareChatKeys = {
  thread: (token) => ['share-chat-thread', token],
  messages: (threadId) => ['share-chat-messages', threadId],
  comments: (token) => ['share-comments', token],
};

export async function resolveShareChatThread({ token, password }) {
  const { data } = await api.post(
    `/shares/public/${token}/chat/thread`,
    {},
    { params: password ? { password } : {} },
  );
  return data;
}

export async function listShareChatMessages({ token, page = 1, limit = 30 }) {
  const { data } = await api.get(`/shares/public/${token}/chat/messages`, {
    params: { page, limit },
  });
  return data;
}

export async function postShareChatMessage({ token, body, password }) {
  const { data } = await api.post(`/shares/public/${token}/chat/messages`, { body, password });
  return data;
}

/** Same dedupe-and-prepend logic as `chatApi.insertChatMessage`, keyed under `shareChatKeys`. */
export function insertShareChatMessage(queryClient, threadId, message) {
  queryClient.setQueryData(shareChatKeys.messages(threadId), (old) => {
    if (!old?.pages?.length) return old;
    if (old.pages.some((p) => p.data.some((m) => m.id === message.id))) return old;
    const [first, ...rest] = old.pages;
    return { ...old, pages: [{ ...first, data: [message, ...first.data] }, ...rest] };
  });
}

export async function listShareComments({ token, password }) {
  const { data } = await api.get(`/shares/public/${token}/comments`, {
    params: password ? { password } : {},
  });
  return data;
}

export async function createShareComment({ token, body, parentCommentId, password }) {
  const { data } = await api.post(`/shares/public/${token}/comments`, {
    body,
    parentCommentId,
    password,
  });
  return data;
}

export { API_BASE_URL };
